import React, { useState } from "react";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import Switch from "react-switch";

const ViewOfferDetailsOnline = ({ onClickshowView, onClickCloseView }) => {
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const [checkedBox, setCheckedBox] = useState(false);

  const handleChangeSwitch = (e) =>
    setCheckedBox({ checkedBox: !checkedBox.checkedBox });
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  return (
    <>
      <Modal
        show={onClickshowView}
        onHide={onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Offer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <Image
                src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                alt="View"
                title="View"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pl-3 row">
              <Col lg={10} xl={8} className="d-flex flex-column justify-content-between">
                <div className="f24-500">Mc Donald’s Review</div>
                <div className="f14-400">84/36, N Main Rd, Koregaon Park Annexe Mundhwa, Pune, Maharashtra 411001</div>
              </Col>
            </div>
          </div>
          <hr />
          <div className="enTabs d-flex flex-wrap align-items-center mb-4 mb-2">
            <Button
              variant="link"
              onClick={(e) => handleTab("1")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "1" ? "active" : ""
              }`}
            >
              General Information
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab("2")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "2" ? "active" : ""
              }`}
            >
              Offer Settings
            </Button>            
          </div>
          {selectedTab === "1" && (
            <React.Fragment>
              <div className="enGrayBorderBox">
            <Row className="px-4">
              <Col lg={7} md={12}>
                <Row>
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3">My Offers</div>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/offer.png")}
                          alt="View"
                          title="View"
                          fluid
                        />
                        <div className="enSuccessLBL mt-2">Online</div>
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">Buy 1 Get 1 Free</div>
                        <div className="f12-400">Avail Offer on All Items</div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} className="py-3">
                    <div className="f12-500 pb-3">Start -End Date</div>
                    <div className="f12-500">25th Feb 20</div>
                    <div className="f12-500 pl-4 py-1">to</div>
                    <div className="f12-500 text-red">25th Mar 20</div>
                  </Col>
                </Row>
              </Col>
              <Col lg={5} md={12}>
                <Row>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Discount Type</div>
                    <div className="f12-500">Percentage</div>
                  </Col>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Min Discount</div>
                    <div className="f12-500">10</div>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code Usage Limit</div>
                <div className="f14-400">30</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Views</div>
                <div className="f14-400">20</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Used</div>
                <div className="f14-400">10</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code</div>
                <div className="f14-400">ASCFGFML12</div>
              </Col>
            </Row>
          </div>
          <div className="pt-4 f12-400 opacity5">Offer Name</div>
          <div className="d-flex align-items-center pt-2">
            <div className="f16-500">
              Super excited to get 50% off one beer buy 1 get 1
            </div>
            <div className="enSuccessLBL ml-2">Online</div>
          </div>
          <div className="pt-4 f12-400 opacity5">Description</div>
          <div className="pt-2 f12-400">
            This is one of the best Offers you can get in your life , visit this
            place if you want to Have a time of your life, food here Is
            awesomeThis is one of the best Offers you can get in your life ,
            visit this place if you want to Have a time of your life, food here
            is awesome This is one of the best Offers you can get in your life ,
            visit this place if you want to Have a time of your life food here
            Is awesome
          </div>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">12/12/2020</div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">05:00 PM</div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">End Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">12/12/2020</div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">End Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">09:00 PM</div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Coupon Code</div>
              <div className="f16-700">ASCFGFML12</div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Maximum Usage Limit</div>
              <div className="f16-700">100</div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">Status</div>
              <div className="d-flex align-items-center">
                <div className="f14-500 mr-2">Inactive</div>
                <Switch
                  onChange={handleChangeSwitch}
                  checked={checkedBox.checkedBox}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={24}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={15}
                  width={41}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
              </div>
            </Col>
          </Row>
          <hr />
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">View Video</div>
            <div className="enIMG105">
              <Image
                src={require("../../../../../../assets/images/UserManagement/offer.png")}
                alt="offer"
                title="offer"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pt-2 f12-400">
              (You can upload only 1 pic per offer 700 x 420 pixels)
            </div>
          </div>
          <div className="pb-4">
            <div className="pb-2 f12-400 opacity5">View Video</div>
            <div className="enIMG105">
              <Image
                src={require("../../../../../../assets/images/UserManagement/offer.png")}
                alt="offer"
                title="offer"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pt-2 f12-400">
              (You can upload only 1 pic per offer 700 x 420 pixels)
            </div>
          </div>
          <div className="pb-4">
            <div className="f12-400 opacity5">Terms and Conditions</div>
            <div className="pt-2 f12-400">
              This is one of the best Offers you can get in your life , visit
              this place if you want to Have a time of your life, food here Is
              awesomeThis is one of the best Offers you can get in your life ,
              visit this place if you want to Have a time of your life, food
              here is awesome This is one of the best Offers you can get in your
              life , visit this place if you want to Have a time of your life
              food here Is awesome
            </div>
          </div>
          <div className="pb-4">
            <div className="f12-400 opacity5">Refund & Cancellation</div>
            <div className="pt-2 f12-400">
              This is one of the best Offers you can get in your life , visit
              this place if you want to Have a time of your life, food here Is
              awesomeThis is one of the best Offers you can get in your life ,
              visit this place if you want to Have a time of your life, food
              here is awesome This is one of the best Offers you can get in your
              life , visit this place if you want to Have a time of your life
              food here Is awesome
            </div>
          </div>
          </React.Fragment>)}
          {selectedTab === "2" && (
            <React.Fragment>
              <div className="enGrayBorderBox">
            <Row className="px-4">
              <Col lg={7} md={12}>
                <Row>
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3">My Offers</div>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/offer.png")}
                          alt="View"
                          title="View"
                          fluid
                        />
                        <div className="enSuccessLBL mt-2">Online</div>
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">Buy 1 Get 1 Free</div>
                        <div className="f12-400">Avail Offer on All Items</div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} className="py-3">
                    <div className="f12-500 pb-3">Start -End Date</div>
                    <div className="f12-500">25th Feb 20</div>
                    <div className="f12-500 pl-4 py-1">to</div>
                    <div className="f12-500 text-red">25th Mar 20</div>
                  </Col>
                </Row>
              </Col>
              <Col lg={5} md={12}>
                <Row>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Discount Type</div>
                    <div className="f12-500">Percentage</div>
                  </Col>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Min Discount</div>
                    <div className="f12-500">10</div>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code Usage Limit</div>
                <div className="f14-400">30</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Views</div>
                <div className="f14-400">20</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Used</div>
                <div className="f14-400">10</div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code</div>
                <div className="f14-400">ASCFGFML12</div>
              </Col>
            </Row>
          </div>
          <Row className>
          <Col lg={3} md={6} className="py-3">
            <div className="f12-400 opacity5 pb-3">Coupon Discount Type</div>
            <div className="f16-500">Percentage</div>
          </Col>
          <Col lg={3} md={6} className="py-3">
            <div className="f12-400 opacity5 pb-3">Coupon Discount</div>
            <div className="f16-500">10%</div>
          </Col>
          <Col lg={6} md={12} className="py-3">
            <div className="f12-400 opacity5 pb-3">Applicable To Services</div>
            <div className="f16-500"><span className="mr-3">Takeaway</span> <span className="mr-3">Curb side</span> <span className="mr-3">Dine-In</span></div>
          </Col>
          </Row>          
          </React.Fragment>)}
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f14-400">+91-xxxxxx7890</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Offer ID</div>
                  <div className="f14-400">1234567890</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Start Date / Time</div>
                  <div className="f14-400">25th December 2020</div>
                  <div className="f14-400">05:00 PM</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">End Date / Time</div>
                  <div className="f14-400">25th December 2020</div>
                  <div className="f14-400">09:00 PM</div>
                </Col>
                <Col md={12}>
                  <hr />
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">25th December 2020</div>
                  <div className="f14-400">05:00 PM</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">25th December 2020</div>
                  <div className="f14-400">05:00 PM</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Pont of Entry</div>
                  <div className="f14-400">Menually Added</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Maximum Usage Limit</div>
                  <div className="f14-400">100</div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <tr>
                  <th className="">
                    <div className="f12-500">Date</div>
                  </th>
                  <th>
                    <div className="f12-500">Operation</div>
                  </th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <div className="f12-500">13th August, 2019</div>
                    <div className="f12-500">06:30 PM</div>
                  </td>
                  <td>
                    <div className="f12-500">
                      Seating status changed from not seated to seated
                    </div>
                  </td>
                  <td>
                    <div className="f12-500">You</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="f12-500">13th August, 2019</div>
                    <div className="f12-500">06:30 PM</div>
                  </td>
                  <td>
                    <div className="f12-500">
                      Seating status changed from not seated to seated
                    </div>
                  </td>
                  <td>
                    <div className="f12-500">Kinza</div>
                  </td>
                </tr>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewOfferDetailsOnline;
